import { render } from "./BookingForm.vue?vue&type=template&id=0b821e3c"
import script from "./BookingForm.vue?vue&type=script&lang=js"
export * from "./BookingForm.vue?vue&type=script&lang=js"

import exportComponent from "/home/airsxm/domains/airsxm.ridders.dev/public_laravel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__